import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';

import htmr from 'htmr';
import { useUserStore } from '../stores/userStore';

export const CopyrightComponent: React.FC<{
  ml?: number;
}> = ({ ml }) => {
  const [copyMessage, setCopyMessage] = useState(
    'Copyright (c) 2024 WinFacil Corp'
  );
  const { displayContentConfig } = useUserStore();

  useEffect(() => {
    if (displayContentConfig.copyrightMessage) {
      setCopyMessage(displayContentConfig.copyrightMessage);
    }
  }, [displayContentConfig]);

  return (
    <Box component="section" sx={{ p: 2, border: '1px dashed grey' }} style={{marginLeft: ml}}>
      <Typography className="flex justify-center">
        {htmr(copyMessage)}
      </Typography>
    </Box>
  );
};
